import { ReactElement, useState } from "react";
import StyledTableRow from "../../../components/styledTableRow";
import { IProduction, IProductionExtended } from "../../../types";
import {
  Box,
  Collapse,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Tooltip,
  Typography
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { formatDate, formatDateTimeWithSeconds } from "../../../system/utils";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Detail from "../../../components/dialogs/detail";
import HeatInformation from "../../production/components/heatInformation";
import LRFHeatInformation from "../lrf/lrfHeatInformation";
import CasterHeatInformation from "../caster/casterHeatInformation";

interface IProps {
  production: IProduction;
}

interface IDetailDialog<T> {
  open: boolean;
  item: T | null;
}

const ProductionTableRow = ({ production }: IProps): ReactElement => {
  const [open, setOpen] = useState(false);
  const [openDetail, setOpenDetail] = useState<IDetailDialog<IProductionExtended>>({ open: false, item: null });

  return (
    <>
      <StyledTableRow hover={true} role="checkbox" tabIndex={-1} >
        <TableCell className="table-cell">
          <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>

        <TableCell>
          {production.reference}
        </TableCell>
        <TableCell>
          {formatDateTimeWithSeconds(production.beginDatetime)}
        </TableCell>
        <TableCell>
          {formatDateTimeWithSeconds(production.endDatetime)}
        </TableCell>
        <TableCell />
        <TableCell />
        <TableCell />
        <TableCell />
      </StyledTableRow>
      <TableRow >
        <TableCell style={{ paddingBottom: 0, paddingTop: 0, border: "none" }} colSpan={6}  className="table-cell">
          <Collapse in={open} timeout="auto" unmountOnExit={true}>
            <Box sx={{ m: 1 }}>
              <Typography variant="h6" gutterBottom={true} component="div">
                Detail
              </Typography>
              <Table size="small" stickyHeader={true}  aria-label="machines">
                <TableHead>
                  <TableRow>
                    <TableCell className="table-header"/>
                    <TableCell className="table-header">Machine</TableCell>
                    <TableCell className="table-header">Factory Day</TableCell>
                    <TableCell className="table-header">Shift</TableCell>
                    <TableCell className="table-header">Crew</TableCell>
                    <TableCell className="table-header">Begin</TableCell>
                    <TableCell className="table-header">End</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  { production.productionMachines.map(machineData => {

                    return (
                      <TableRow key={`detail-${machineData.productionMachineID}`} hover={true}>
                        <TableCell className="table-cell">
                          <IconButton aria-label="edit" size={"small"} onClick={() => setOpenDetail({ open: true, item: machineData })}>
                            <Tooltip title="Show Detail">
                              <OpenInNewIcon/>
                            </Tooltip>
                          </IconButton>
                        </TableCell>

                        <TableCell className="table-cell">
                          {machineData.machine.name}
                        </TableCell>

                        <TableCell className="table-cell">
                          {formatDate(machineData.shiftHistory.factoryDay)}
                        </TableCell>

                        <TableCell className="table-cell">
                          {machineData.shiftHistory.name}
                        </TableCell>

                        <TableCell className="table-cell">
                          {machineData.crew.name}
                        </TableCell>

                        <TableCell className="table-cell">
                          {formatDateTimeWithSeconds(machineData.beginDatetime)}
                        </TableCell>

                        <TableCell className="table-cell">
                          {formatDateTimeWithSeconds(machineData.endDatetime)}
                        </TableCell>

                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
      {openDetail.open && openDetail.item &&
        <Detail closed={() => setOpenDetail({ open: false, item: null })} fullWidth={true} maxWidth={"xl"} title="Detail">
          <>
            {openDetail.item.__typename === "EAFProduction" && <HeatInformation productionItem={openDetail.item} height={500}/>}
            {openDetail.item.__typename === "LRFProduction" && <LRFHeatInformation productionItem={openDetail.item} height={500}/>}
            {openDetail.item.__typename === "CasterProduction" && <CasterHeatInformation productionItem={openDetail.item} height={500}/>}
          </>
        </Detail>
      }
    </>
  );
};

export default ProductionTableRow;
